"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getContentErrorType = exports.hasLibraryItemCorruptedError = exports.getErrorMessage = void 0;
var lodash_1 = require("lodash");
var constants_1 = __importDefault(require("../constants"));
var getErrorMessage = function (e, defaultMessage) {
    return lodash_1.get(e, 'response.data.errors[0].apiErrorMessage', defaultMessage);
};
exports.getErrorMessage = getErrorMessage;
var getErrors = function (e) { return lodash_1.get(e, 'response.data.errors', []); };
var hasError = function (errors, errorCode) {
    return !!errors.find(function (_) { return _.apiErrorCode === errorCode; });
};
var hasLibraryItemCorruptedError = function (e) {
    return hasError(getErrors(e), constants_1.default.API_ERROR_CODES.LIBRARY_ITEM_CORRUPTED);
};
exports.hasLibraryItemCorruptedError = hasLibraryItemCorruptedError;
var getContentErrorType = function (e) {
    var errors = getErrors(e);
    var showableErrorCodes = [constants_1.default.API_ERROR_CODES.VALIDATION_ERROR];
    var errorCodesList = Object.values(constants_1.default.API_ERROR_CODES);
    var showableError = errors.find(function (_a) {
        var _b = _a === void 0 ? {} : _a, apiErrorCode = _b.apiErrorCode;
        if (apiErrorCode && apiErrorCode.toString().match(/E100/g)) {
            return errorCodesList.includes(apiErrorCode);
        }
        return showableErrorCodes.includes(apiErrorCode);
    });
    if (showableError &&
        showableError.apiErrorCode &&
        constants_1.default.API_ERROR_MAPPING[showableError.apiErrorCode]) {
        showableError.apiErrorMessage =
            constants_1.default.API_ERROR_MAPPING[showableError.apiErrorCode];
    }
    return showableError || 'publish';
};
exports.getContentErrorType = getContentErrorType;
